import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'logzy-table-loader',
  templateUrl: './table-loader.component.html',
  styleUrls: ['./table-loader.component.scss']
})
export class TableLoaderComponent implements OnInit {
  @Input() set2: boolean = false;
  @Input() rowNumbers:number[]=[0,1,2,3,4];
  @Input() colNumbers:number[]=[0,1,2,3,4];
  @Input() minWidth:boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
